export enum EPartnerUtmSource {
  N1 = 'n1',
  Bankiru = 'bankiru',
  AlfaBank = 'alfa-bank',
}

export const INTRO_SCREEN_PARTNER_LOGO = {
  [EPartnerUtmSource.N1]: 'https://static.cdn-cian.ru/frontend/e2e-form-assets/demand/icons/cian_n1.svg',
  [EPartnerUtmSource.Bankiru]: 'https://static.cdn-cian.ru/frontend/e2e-form-assets/demand/icons/cian_bankiru.svg',
  [EPartnerUtmSource.AlfaBank]: 'https://static.cdn-cian.ru/frontend/e2e-form-assets/demand/icons/cian_alfa-bank.svg',
};
